import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

import { ModalDialog } from 'core-components/library/modalDialog'
import { HPContactRequestEditor } from 'partner360/features/hpContacts'
import { useLeadPbmId } from 'partner360/features/hpContacts/model'

interface IRequestEditorProps {
  isVisible: boolean
  partnerId: string
  partnerName?: string
  currentHpContactRequest: IFormJBPHPContactChangeRequest
  onClose: () => void
  onApply: (item: IFormJBPHPContactChangeRequest) => Promise<void>
}

export const RequestEditor = ({
  isVisible,
  partnerId,
  partnerName,
  currentHpContactRequest,
  onClose,
  onApply,
}: IRequestEditorProps) => {
  const [leadPbmId] = useLeadPbmId({
    partnerId,
  })

  if (!isVisible) {
    return null
  }

  return (
    <ModalDialog
      show
      onClose={onClose}
      size="sm"
      content={HPContactRequestEditor}
      contentProps={{
        isVisible: isVisible,
        shouldKeepCurrentUser: true,
        onCancel: onClose,
        currentHpContactRequest: currentHpContactRequest,
        partnerId,
        partnerName,
        leadId: leadPbmId,
        currentRole: currentHpContactRequest.Roles,
        onApply,
      }}
    />
  )
}
